import { AliceApp } from 'client/model/skill';
import { nanoid } from 'nanoid/non-secure';

import { Operation, OperationEvent, OperationType } from '../model/operation';

interface CreateOperationParams {
    aliceApp: AliceApp;
    type: OperationType;
}

export const createOperation = ({ aliceApp, type }: CreateOperationParams): Operation => {
    return {
        comment: '',
        createdAt: new Date().toJSON(),
        itemId: aliceApp.id,
        itemName: aliceApp.name,
        type,
        id: nanoid(),
    };
};

export const sortEventsByDate = (aEvent: OperationEvent, bEvent: OperationEvent) => {
    if (aEvent?.operation?.createdAt > bEvent?.operation?.createdAt) {
        return -1;
    }
    if (bEvent?.operation?.createdAt > aEvent?.operation?.createdAt) {
        return 1;
    }
    return 0;
};
